import React from 'react';
import { EntityForm } from '../../widgets/Forms';
import { SelectItem } from '../../widgets/SelectItem';


export default function APPMaintenanceSearchForm(props) {

    return (
        <EntityForm ref={React.createRef()} viewId="GrantSetup" values={props.data}
            useCustomSettings={false} valueChangeHandler={props.valueChangeHandler}>
            {form =>
                <form className={form.classes.container} id="SearchForm">
                    <td>
                        <SelectItem
                            dataUrl="api/sims/APPMaintenance/GetLookupList?listId=APPFinancialYear"
                            id="FinancialYearID"
                            label="Financial Year"
                            className="w-150"
                            form={form}
                            InputProps={{
                                readOnly: props.disableFields
                            }}
                            required
                        />
                    </td>
                    <td>
                        <SelectItem
                            dataUrl="api/sims/APPMaintenance/GetLookupList?listId=APPProgrammeStructure"
                            id="APPProgrammeStructureID"
                            label="Programme Structure"
                            className="w-150"
                            form={form}
                            InputProps={{
                                readOnly: props.disableFields
                            }}
                        />
                    </td>
                    <br>
                    </br>
                </form>
            }
        </EntityForm>
    );
}
